import {
  NBS_API_SEARCH_USERS_SUCCESS,
  RESET_SEARCH_USER_LIST,
  NBS_API_BLOCK_USER_SUCCESS,
  NBS_API_DELETE_USER_CHAT_AND_UNMATCH_SUCCESS
} from '../../constants/actions';

const initialState = {
  data: [],
  lastUserId: '',
  end: false
};

export default function reducer (state = initialState, action = {}) {
  switch (action.type) {
    case NBS_API_SEARCH_USERS_SUCCESS:
      const currentState = {...state};
      const { users, end } = action.response;
      const lastUserId = end ? '' : users[users.length - 1].user_id;
      if (action.startOver) {
        return {lastUserId, end, data: users};
      } else {
        return {lastUserId, end, data: [...currentState.data, ...users]};
      }
    case RESET_SEARCH_USER_LIST:
      return initialState;
    case NBS_API_DELETE_USER_CHAT_AND_UNMATCH_SUCCESS:
    case NBS_API_BLOCK_USER_SUCCESS:
      const currentUsers = [...state.data];
      const newUsers = currentUsers.filter(user => user.user_id !== action.userId);
      return {...state, data: newUsers};
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/userListSearch.js